import { Modal } from '@/components/Modal'

import { modalId } from '../hooks/useController'
import { SupportTicket } from '../types'
import { Content } from './Content'

interface Props {
  ticket?: SupportTicket
}

export function Root(props: Props) {
  const { ticket = {} } = props
  return (
    <Modal modalId={modalId}>
      <Content {...ticket} />
    </Modal>
  )
}
